import Icon from './Icon';

export * from './Icon';
export default Icon;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Icon/index.js